export const VNDIALOGS_CONFIRM_PAYMENT_READY = 'VNDIALOGS_CONFIRM_PAYMENT_READY'
export const VNDIALOGS_CONFIRMATION_DIALOG = 'VNDIALOGS_CONFIRMATION_DIALOG'
export const VNDIALOGS_CUSTOMER_PAYMENT = 'VNDIALOGS_CUSTOMER_PAYMENT'
export const VNDIALOGS_CUSTOMER_VIEWING_RECEIPT = 'VNDIALOGS_CUSTOMER_VIEWING_RECEIPT'
export const VNDIALOGS_CUSTOMER_PAYING_WITH_CARD = 'VNDIALOGS_CUSTOMER_PAYING_WITH_CARD'
export const VNDIALOGS_TRANSACTION_COMPLETE = 'VNDIALOGS_TRANSACTION_COMPLETE'
export const VNDIALOGS_TRANSACTION_ERROR = 'VNDIALOGS_TRANSACTION_ERROR'
export const VNDIALOGS_CUSTOMER_ENTERING_TIP = 'VNDIALOGS_CUSTOMER_ENTERING_TIP'
export const VNDIALOGS_CARD_AUTH_STEP_ONE = 'VNDIALOGS_CARD_AUTH_STEP_ONE'
export const VNDIALOGS_CARD_AUTH_STEP_TWO = 'VNDIALOGS_CARD_AUTH_STEP_TWO'
export const VNDIALOGS_KITCHEN_PRINTER_ERROR_DIALOG = 'VNDIALOGS_KITCHEN_PRINTER_ERROR_DIALOG'
export const VNDIALOGS_BACK_BAR_FINALIZE_MODALS = 'VNDIALOGS_BACK_BAR_FINALIZE_MODALS'
export const VNDIALOGS_OFFLINE_DIALOG = 'VNDIALOGS_OFFLINE_DIALOG'
export const VNDIALOGS_CONNECTION_REQUIRED_DIALOG = 'VNDIALOGS_CONNECTION_REQUIRED_DIALOG'
export const VNDIALOGS_STOP_SYNC_DIALOG = 'VNDIALOGS_STOP_SYNC_DIALOG'
export const VNDIALOGS_BALANCE_LOOKUP = 'VNDIALOGS_BALANCE_LOOKUP'
export const VNDIALOGS_PRINTER_NOT_CONFIGURED_DIALOG = 'VNDIALOGS_PRINTER_NOT_CONFIGURED_DIALOG'
export const VNDIALOGS_OPEN_PRICE_RICH_CHECKOUT_NOT_SUPPORTED = 'VNDIALOGS_OPEN_PRICE_RICH_CHECKOUT_NOT_SUPPORTED'
export const VNDIALOGS_PRICE_ADJUSTMENT_CONFIRM_EXIT = 'VNDIALOGS_PRICE_ADJUSTMENT_CONFIRM_EXIT'
export const VNDIALOGS_PRICE_ADJUSTMENT_DIALOG = 'VNDIALOGS_PRICE_ADJUSTMENT_DIALOG'
export const VNDIALOGS_CANNOT_REOPEN_TAB_DIALOG = 'VNDIALOGS_CANNOT_REOPEN_TAB_DIALOG'
export const VNDIALOGS_REOPEN_TAB_DIALOG = 'VNDIALOGS_REOPEN_TAB_DIALOG'
export const VNDIALOGS_CANNOT_REOPEN_UNSYNCED_TAB = 'VNDIALOGS_CANNOT_REOPEN_UNSYNCED_TAB'
export const MOBILE_SCAN_PAYMENT_DIALOG = 'MOBILE_SCAN_PAYMENT_DIALOG'
export const VN_DIALOGS_CFD_NOT_PAIRED_DIALOG = 'VN_DIALOGS_CFD_NOT_PAIRED_DIALOG'
export const VNDIALOGS_CFD_BLOCKING_DIALOG = 'VNDIALOGS_CFD_BLOCKING_DIALOG'
export const VNDIALOGS_CFD_PAIRED_DIALOG = 'VNDIALOGS_CFD_PAIRED_DIALOG'
export const VN_SET_MESSAGE_RECEIPT_ERROR_DIALOG = 'VN_SET_MESSAGE_RECEIPT_ERROR_DIALOG'
export const VNDIALOGS_VN_TIP_ENTRY_DIALOG = 'VNDIALOGS_VN_TIP_ENTRY_DIALOG'
export const VNDIALOGS_TAX_DISPLAY_DIALOG = 'VNDIALOGS_TAX_DISPLAY_DIALOG'
export const VN_ENTERING_INPUT_DIALOG = 'VN_ENTERING_INPUT_DIALOG'
export const VN_START_A_TAB_MODAL = 'VN_START_A_TAB_MODAL'
export const VN_TAB_PAYMENT_METHOD_MODAL = 'VN_TAB_PAYMENT_METHOD_MODAL'
export const VN_DEBUG_DIALOG = 'VN_DEBUG_DIALOG'
export const VN_TRANSFER_TAB_MODAL = 'VN_TRANSFER_TAB_MODAL'
export const VN_MOBILE_QR_RECEIPT_DIALOG = 'VN_MOBILE_QR_RECEIPT_DIALOG'
export const CONFIRM_DEFAULT_TIP_MODAL = 'CONFIRM_DEFAULT_TIP_MODAL'
export const VN_CASH_PAYMENT_ALREADY_APPLIED_MODAL = 'VN_CASH_PAYMENT_ALREADY_APPLIED_MODAL'
